import pick from "lodash/pick";
import { selectedPolygonTypes } from "../Common/Constants";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
// import { flattenDeep } from "lodash";
const { motor_spots } = selectedPolygonTypes;

// const getMotorSportsPerHourRange = data => {
// 	const popular_times = data
// 		.map(obj => {
// 			if (!obj.popular_times) return [];

// 			const { popular_times } = obj;

// 			let allValues = popular_times.map(({ data }) => {
// 				return data;
// 			});

// 			return flattenDeep(allValues);
// 		})
// 		.filter(obj => obj.length > 0);
// 	// get the max and min of the popular times
// 	const min = Math.min(...popular_times.map(obj => Math.min(...obj)));
// 	const max = Math.max(...popular_times.map(obj => Math.max(...obj)));
// 	// const min = Math.min(...data.map(obj => obj.population));
// 	// const max = Math.max(...data.map(obj => obj.population));

// 	return { min, max };
// };

const getMotorSportsPolygonsRange = ({ data }) => {
	let min = Number.MAX_SAFE_INTEGER;
	let max = Number.MIN_SAFE_INTEGER;
	data.forEach(obj => {
		if (obj.motor_sports_population < min) min = obj.motor_sports_population;
		if (obj.motor_sports_population > max) max = obj.motor_sports_population;
	});
	// for (let [, obj] of data.entries()) {
	// 	if (obj.motor_sports_population < min) min = obj.motor_sports_population;
	// 	if (obj.motor_sports_population > max) max = obj.motor_sports_population;
	// }
	return { min, max };
};
/**
 * Returns a red gradient color based on the provided min, max, and shops values.
 *
 * @param range - An object containing the minimum and maximum values: { min, max }
 * @param shops - The shops value to base the color intensity on.
 * @returns A string representing an HSL color.
 *
 * For example, if shops is near the minimum, it returns a light red.
 * If shops is near the maximum, it returns a darker, more intense red.
 */
// function getRedGradient(range, shops) {
// 	const { min, max } = range;

// 	// Clamp shops between min and max
// 	const clampedShops = Math.max(min, Math.min(shops, max));

// 	// Calculate the ratio within the range (0 when shops==min, 1 when shops==max)
// 	const ratio = (clampedShops - min) / (max - min);

// 	// We'll use HSL to vary the lightness.
// 	// When ratio=0, use high lightness (e.g. 90%) for light red.
// 	// When ratio=1, use lower lightness (e.g. 40%) for deep red.
// 	const lightness = 90 - ratio * 50; // Interpolate lightness from 90% down to 40%

// 	// Return an HSL string.
// 	return `hsl(0, 100%, ${lightness}%)`;
// }

const getAdditionalShopsPolygon = locations => {
	// const range = getMotorSportsPolygonsRange({ data: locations });
	return {
		polygons: locations.map((obj, ind) => {
			const { motor_sports_population: filterData, popular_times } = obj;
			return {
				id: ind,
				_id: ind,

				coordinates: obj.coordinates,
				style: {
					fillColor: "#FF000077",
					strokeColor: "#000000",
					zindex: 10
				},
				data: {
					filterData,
					key: "population",
					popular_times
				},
				polygonClick: true,
				type: motor_spots
			};
		})
	};
};

const getAdditionalSlider = ({ locations, dispatch }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_MOTOR_SPORTS_SLIDER)) return null;
	// eslint-disable-next-line no-unused-vars
	// const { min: trafficMin, max: trafficMax } = getMotorSportsPerHourRange(locations);
	// const trafficSlider = {
	// 	min: trafficMin,
	// 	max: trafficMax,
	// 	sliderHandler: value => {
	// 		dispatch({ type: "filterPolygons", value: { value, type: `${motor_spots}-trafficData` } });
	// 	},
	// 	type: `${motor_spots}-trafficData`
	// 	// sliderType: "traffic"
	// };

	// const weeklySlider = {
	// 	min: 0,
	// 	max: 6,
	// 	sliderHandler: value => {
	// 		dispatch({ type: "filterPolygons", value: { value, type: `${motor_spots}-weeklyData` } });
	// 	},
	// 	type: `${motor_spots}-weeklyData`,
	// 	sliderType: "weekly"
	// };

	// const hourlySlider = {
	// 	min: 0,
	// 	max: 23,
	// 	sliderHandler: value => {
	// 		dispatch({ type: "filterPolygons", value: { value, type: `${motor_spots}-hourlyData` } });
	// 	},
	// 	type: `${motor_spots}-hourlyData`,
	// 	sliderType: "hourly"
	// };

	const { min, max } = getMotorSportsPolygonsRange({ data: locations });

	return [
		{
			min,
			max,
			sliderHandler: value => {
				dispatch({ type: "filterPolygons", value: { value, type: `${motor_spots}` } });
			},
			type: `${motor_spots}`
		}
	];

	// return [weeklySlider, hourlySlider, trafficSlider];
};

const MotorSportsServices = {
	all: ({ locations, sliderHandler, type, dispatch }) => {
		return {
			...pick(getAdditionalShopsPolygon(locations), ["polygons"]),
			...{ slider: getAdditionalSlider({ sliderHandler, locations, type, dispatch }) }
		};
	},
	polygons: ({ locations }) => {
		return pick(getAdditionalShopsPolygon(locations), ["polygons"]);
	}
};

export default MotorSportsServices;
export { getAdditionalShopsPolygon, getAdditionalSlider };
